// extracted by mini-css-extract-plugin
module.exports = {"scroll":"control-properties_scroll__2mZ5I"};